import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { toggleGetStarted } from "../../actions/globalAction";
import Modal from "../UIComponents/CustomModal/Modal";
import "./GettingStartedModal.scss";
import { monthlyData, productNames } from "../SubscriptionModule/utils";
import confetti from "canvas-confetti";
import { ReactComponent as TickIcon } from "../../assets/svg/progress-completed.svg";
import { Link } from "react-router-dom";

class GettingStartedModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.modalRef = createRef();
    }

    componentDidUpdate(prevProps) {
        if (this.props.showGetStarted && prevProps.showGetStarted !== this.props.showGetStarted) {
            this.confetti();
        }
    }

    confetti = () => {
        var myCanvas = document.createElement("canvas");
        if (this.modalRef?.current) {
            this.modalRef.current.appendChild(myCanvas);

            var myConfetti = confetti.create(myCanvas, {
                resize: true,
                useWorker: true,
            });
            myConfetti({
                particleCount: 250,
                spread: 200,
            });
        }
    };

    hideModal = () => {
        sessionStorage.removeItem("getStarted");
        this.props.toggleGetStarted(false);
    };

    iconUrl = (val) => {
        if (val === "tick-green") return <TickIcon />;
        else if (val === "tick-yellow") return <img src={`https://www.radarr.com/wp-content/uploads/2022/01/tick-yellow.svg`} />;
        else return <img src={"https://www.radarr.com/wp-content/uploads/2022/01/cross.svg"} />;
    };

    navigateTo = (path) => {
        this.props.toggleGetStarted(false);
        this.props.history.push(path);
    };

    getItems = () => {
        let elements = [];
        monthlyData.forEach((d, i) => {
            if (d[this.props.packageObj?.package_code]?.color !== "green") return null;
            elements.push(
                <div key={i + d.name} className="checkout-current-package-item">
                    <div className="query-row">
                        <div className={`bullet-icon ${d[this.props.packageObj?.package_code].color}`}>
                            {this.iconUrl(d[this.props.packageObj?.package_code].icon)}
                        </div>
                        <div className="info">
                            <p className="query-name">{d.name}</p>
                            <p> {d[this.props.packageObj?.package_code].content}</p>
                        </div>
                    </div>
                </div>,
            );
        });

        return (
            <>
                <div className="column-one">{elements.slice(0, elements.length / 3)}</div>
                <div className="column-two">{elements.slice(elements.length / 3, (2 * elements.length) / 3)}</div>
                <div className="column-three">{elements.slice((2 * elements.length) / 3)}</div>
            </>
        );
    };

    render() {
        return (
            <Modal forwardedRef={this.modalRef} className="getting-started-modal" show={this.props.showGetStarted} onClose={this.hideModal}>
                <Modal.Header></Modal.Header>
                <Modal.Content>
                    <h1>Congratulations!</h1>
                    <h2>Welcome to the {productNames[this.props.packageObj?.package_code]}!</h2>
                    {/* {this.props.packageObj?.subscription?.status === "trialing" && (
                        <p>You just unlocked the 7-day free trial for {productNames[this.props.packageObj?.package_code]}</p>
                    )} */}
                    <div className="selected-plan">
                        <div className="header">
                            <span>
                                Your <span className="bold">{productNames[this.props.packageObj?.package_code]}</span> includes these features
                            </span>
                        </div>
                        <div className="selected-plan-features">{this.getItems()}</div>
                    </div>
                    <div className="action-buttons">
                        <Link to="/gettingStarted">
                            <button onClick={this.hideModal}>Get Started</button>
                        </Link>
                    </div>
                </Modal.Content>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    showGetStarted: state.globalReducer.showGetStarted,
    packageObj: state.globalReducer.packageObj,
});

const mapDispatchToProps = (dispatch) => ({
    toggleGetStarted: (data) => dispatch(toggleGetStarted(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GettingStartedModal);
